import { Component, EventEmitter } from "@angular/core";
import { Observable } from "rxjs";

import { ViewService, SecurityService, Security, SearchParams } from "../../../common";

@Component({
  templateUrl: "./security-list-view.html",
  standalone: false,
})
export class SecurityListView {
  public refresh: EventEmitter<void> = new EventEmitter<void>();

  constructor(private viewService: ViewService, private dataService: SecurityService) {
    viewService.setViewData({
      pageTitle: "Security",
      link: { text: "» New", routeData: ["/security/new"] },
    });
  }

  performSearch(searchParams: SearchParams): Observable<Security[]> {
    return this.dataService.all(searchParams);
  }

  navigate(params: any): void {
    this.viewService.router.navigate(["/security"]);
  }

  remove(role: Security) {
    if (window.confirm(`Are you sure you want to delete role ${role.name} ?`)) {
      this.dataService.remove(role.id).subscribe((x) => this.refresh.emit());
    }
  }
}
